export default __webpack_public_path__ + "static/media/sesuatudijogja.a75beeb7.jpg";